const availableOrderStatuses = [
    {
        value: 'pending_payment',
        label: 'Aguardando pagamento'
    },
    {
        value: 'paid',
        label: 'Pago'
    },
    {
        value: 'cancelled',
        label: 'Cancelado'
    }
]

export default availableOrderStatuses
